import { Component,OnInit } from '@angular/core';
import { Service } from '../../../../class/service';
import { Cookies } from '../../../../class/cookies';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { View } from '../../view';
import 'rxjs/add/operator/debounceTime';

@Component({
	moduleId: module.id,
	selector: 'subcodigo-component',
	templateUrl: 'subcodigo.component.html',
})

export class SubcodigoComponent extends View implements OnInit {

	//Modelo de datos
	private model: Object = { PKCodigo:'' };
	//Referencia del codigo
	private ref: String = "";
	//Para validaer si el codigo existe
	private validarCodigo: number = 0;
	//relacionado con el imput del html	--llave primaria
	private PKCodigo = new FormControl();
	

	constructor(public service: Service, public cookies: Cookies) {
		super(service,cookies,"subcodigo-component");
		super.serviceNmae("subcodigo");
		
	}

	ngOnInit() {
		super.filter({
			column:[
				{ name: 'PKCodigo', nickname: 'Codigo' },
				{ name: 'nombre', nickname: 'Nombre' }
			]
		});
		
		//Validar que no exista el codigo
		this.PKCodigo.valueChanges.
			debounceTime(700)
			.subscribe(newValue => {
				if (newValue != null || newValue != undefined) {
					if (newValue != this.model["PKCodigo"]) {
						this.model["PKCodigo"] = newValue;
						this.existeCodigo(newValue);
					}
				}
			});
	}


	//Un nuevo registro, iniciando datos
	private NEW(): void {
		this.PKCodigo.reset();
		this.model = { PKCodigo:'' };
		this.list = false;
		this.action = 'Guardar';
	}

	//Editar en base al codigo de referencia
	private EDIT(codigo: string): void {
		this.ref = codigo;
		this.action = "Actualizar";
		this.list = false;
		this.getModelById();
	}

	//Para obtener y cargar el registro seleccionado
	private getModelById(): void {
		this.state = !this.state;
		this.service.GET('subcodigo/' + this.ref, '').subscribe(res => {
			console.log(res);
			this.model = res["show"][0];
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Validar si guardar o modificar
	private actionCrud(): void {
		if (this.action.toUpperCase() == "GUARDAR") {
			this.save();
		} else {
			this.update();
		}
	}

	//Para eliminar el registro
	private DELETE(codigo: String): void {
		this.state = !this.state;
		this.service.DELETE('subcodigo/delete/' + codigo).subscribe(res => {
			this.getList(this.pagination["current_page"], "");
			if (res["destroy"]) {
				this.openMd("El registro se elimino correctamente", "success");
			} else {
				this.openMd("El registro no se elimino", "danger");
			}
		}, err => {
			console.log(err);
			this.state = !this.state;
			this.openMd(err, "danger");
		});
	}

	//Guardar el registro
	private save(): void {
		this.state = !this.state;
		this.service.POST('subcodigo', { subcodigo: JSON.stringify(this.model) }).subscribe(res => {
			this.state = !this.state;
			this.list = !this.list;
			this.getList(1, "");
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Modificar el registro
	private update(): void {
		this.state = !this.state;
		console.log({subcodigo: JSON.stringify(this.model) });
		this.service.PUT('subcodigo/update/' + this.ref, { subcodigo: JSON.stringify(this.model) }).subscribe(res => {
			console.log(res);
			if (res["update"]) {
				
				this.state = !this.state;
				this.getList(1,"");
				this.openMd("El registro se ha modificado correctamente", "success");
				this.list = !this.list;
			} else {
				this.openMd("El registro no se ha podido modificar", "danger");
			}
		}, err => {
			console.log(err);
		});
	}

	//Validar si existe el codigo
	private existeCodigo(codigo: String) {
		let data = "&codigo=" + codigo;
		this.service.GET("existeCodigo", data).subscribe(res => {
			this.validarCodigo = res["existeCodigo"] ? 2 : 1;
		},
			err => { console.log(err) }
		)
	}
}


// WEBPACK FOOTER //
// ./src/app/component/module/archivo/subcodigo/subcodigo.component.ts